import { render, staticRenderFns } from "./SalesOrderItem.vue?vue&type=template&id=77e81da0&"
import script from "./SalesOrderItem.vue?vue&type=script&lang=js&"
export * from "./SalesOrderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports